export default __webpack_public_path__ + "26acb2fa8fd1de0c9ffd470f8fd0325d.png";